import { SignalSourceEnum as SignalSource } from "app/pages/sales-intelligence/domain/signals/types/signal";

/** @deprecated use `SignalSource` / `signalSourceMap` from "app/pages/sales-intelligence/domain/signals/types/signal" */
export default SignalSource;
